import React, { useContext, useState } from 'react';
import EditAgreedCommission from './EditAgreedCommission';
import { Button } from 'primereact/button';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { AccountContext } from '../../../components/AccountContext';
import { growlErrors } from '../../../utils/NotificationUtil';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { Loading } from '../../../components/Loading';

const CHECK_FOR_UNSETTLED_COMMISSION_MUTATION = gql`
  mutation checkForUnsettledCommissionMutation($input: CheckForUnsettledCommissionInput!) {
    checkForUnsettledCommission(input: $input) {
      unsettledCommissionExists
      unsettledCommissionType
    }
  }
`;

const AgreedCommission = ({ partner, handleShowDialog }) => {
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [checkForUnsettledCommission] = useMutation(CHECK_FOR_UNSETTLED_COMMISSION_MUTATION);

  const {
    id,
    name,
    creditCommissionPercentage,
    noLimitCommissionPercentage,
  } = partner;

  const cancelEditMode = () => {
    setEditMode(false);
  };

  const handleEditModeClick = async () => {
    setLoading(true);

    try {
      const {
        data: {
          checkForUnsettledCommission: { unsettledCommissionExists, unsettledCommissionType },
        },
      } = await checkForUnsettledCommission({
        variables: {
          input: {
            gscId: currentAccount,
            gpId: id,
          },
        },
      });

      if (unsettledCommissionExists) {
        handleShowDialog(name, unsettledCommissionType);
      } else {
        setEditMode(true);
      }
    } catch (errors) {
      growlErrors(growl, errors);
    } finally {
      setLoading(false);
    }
  };

  if (editMode) {
    return <EditAgreedCommission partner={partner} cancelEditMode={cancelEditMode} />;
  }

  return (
    <div className="flex-space-between margin-bottom-0-5">
      <div>{name}</div>
      <div>{id}</div>
      <div>{creditCommissionPercentage}%</div>
      <div>{noLimitCommissionPercentage}%</div>
      <div>
        {loading ? (
          <Loading size="small" />
        ) : (
          <Button type="button" className="p-button-secondary" icon="pi pi-pencil" onClick={handleEditModeClick} />
        )}
      </div>
    </div>
  );
};

export default AgreedCommission;
